import { createSectionForm } from "./sectionFormKit";

// Customer: components/sections/OurLocations/OurLocations.js
const OurLocations = createSectionForm({
  icon: "map-pin-line",
  title: "Our Locations",
  fields: [
    { name: "title", label: "Title", placeholder: "Our Location" },
    {
      name: "locations",
      label: "Locations (Florida, Texas, Tennessee on the map)",
      type: "list",
      itemLabel: "Location",
      maxItems: 3,
      fields: [
        { name: "image", label: "Image", type: "media" },
        { name: "title", label: "Name" },
        { name: "sub_title", label: "Address / Sub Title" },
      ],
    },
  ],
});

export default OurLocations;
